import { ErrorEvent, LoadingEvent, RoomCodeChangedEvent } from "@playroomkit/pr-wars/events";
import { LoadingType } from "@playroomkit/pr-wars/utils";
import { useManager } from "@src/contexts/WarsContext";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface GameLoaderProps {
  roomCode: string | null;
  musicContext: AudioContext;
}

const GameLoader: React.FC<GameLoaderProps> = ({ roomCode, musicContext }) => {

  const manager = useManager();
  const { t, i18n } = useTranslation(["main"]);

  useEffect(() => {

    const createGame = async () => {  
      try {
        if(!roomCode) {
          
          // It is now up to the callers to provide loading messages instead of happening internally
          document.dispatchEvent(new LoadingEvent(30, t('loading-message-1'), LoadingType.MainMenu, false));

          // Create the game
          await manager.createGame(musicContext);

          // Send the next step of the loading messages
          document.dispatchEvent(new LoadingEvent(50, t('loading-message-2'), LoadingType.MainMenu, false));

        } else {
          // It is now up to the callers to provide loading messages instead of happening internally
          document.dispatchEvent(new LoadingEvent(30, t('loading-message-1'), LoadingType.MainMenu, false));

          // Join the game
          await manager.joinGame(roomCode, musicContext);

          // Send the next step of the loading messages
          document.dispatchEvent(new LoadingEvent(50, t('loading-message-2'), LoadingType.MainMenu, false));
        }
  
      } catch(err) {
        document.dispatchEvent(new LoadingEvent(-1, 'error', LoadingType.MainMenu, false));
        document.dispatchEvent(new ErrorEvent(`Error Creating Game: ${err}`, 5000))
      }
    };
  
    createGame();

    return () => {
    }

  }, [manager]);
  
  return null;
};

export default GameLoader;